/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cta_BrowseInputs */

const es_faq_cta_browse = /** @type {(inputs: Faq_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar barcos`)
};

const gl_faq_cta_browse = /** @type {(inputs: Faq_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar barcos`)
};

const en_faq_cta_browse = /** @type {(inputs: Faq_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse boats`)
};

/**
* | output |
* | --- |
* | "Browse boats" |
*
* @param {Faq_Cta_BrowseInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_cta_browse = /** @type {((inputs?: Faq_Cta_BrowseInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cta_BrowseInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_cta_browse(inputs)
	if (locale === "en") return en_faq_cta_browse(inputs)
	return es_faq_cta_browse(inputs)
});